"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Close = _interopRequireDefault(require("./../Icons/Close"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: 5px;\n  background-color: ", ";\n  margin-top: 11px;\n\n  &:before {\n    content: '';\n    width: ", ";\n    transition: ", ";\n    height: 5px;\n    position: absolute;\n    background-color: ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  @media (max-width: 900px) {\n    flex-direction: row;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 19px 20px 15px 22px;\n  border: 1px solid ", ";\n  box-sizing: border-box;\n  justify-content: space-between;\n  /* Backdrop */\n\n  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.05);\n  border-radius: 5px;\n\n  &:last-child {\n    margin-right: 0;\n  }\n\n  img {\n    max-width: 50px;\n  }\n\n  svg {\n    cursor: pointer;\n  }\n\n  span {\n    font-size: 15px;\n  }\n  .fileName {\n    font-weight: 900;\n    margin-right: 1vw;\n    max-width: 10vw;\n  }\n\n  .fileSize {\n    color: #76726e;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Box = _styledComponents.default.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.ui.outline;
});

Box.displayName = 'Box';

var Left = _styledComponents.default.div(_templateObject2());

var Right = _styledComponents.default.div(_templateObject3());

var LoadingBar = _styledComponents.default.div(_templateObject4(), function (_ref2) {
  var loaded = _ref2.loaded;
  return loaded !== null ? '22vw' : 0;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.ui.backgroundLight;
}, function (_ref4) {
  var loaded = _ref4.loaded;
  return "calc(".concat(loaded, " / 100 * 22vw);");
}, function (_ref5) {
  var loaded = _ref5.loaded;
  return loaded === 0 ? null : 'width 1s';
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.brand.primary;
});

var FileBox = function FileBox(_ref7) {
  var className = _ref7.className,
      name = _ref7.name,
      size = _ref7.size,
      source = _ref7.source,
      loaded = _ref7.loaded,
      onClose = _ref7.onClose,
      children = _ref7.children;
  return size ? _react.default.createElement(Box, {
    className: className
  }, _react.default.createElement(Left, null, _react.default.createElement("img", {
    src: source,
    alt: name
  }), _react.default.createElement("span", {
    className: "fileName"
  }, name), size ? _react.default.createElement("span", {
    className: "fileSize"
  }, size) : _react.default.createElement(LoadingBar, {
    loaded: loaded
  })), _react.default.createElement(Right, null, children, _react.default.createElement(_Close.default, {
    onClick: function onClick() {
      return onClose({
        name: name,
        size: size,
        img: source
      });
    }
  }))) : null;
};

FileBox.defaultProps = {
  onClose: Function.prototype
};
FileBox.propTypes = {
  children: _propTypes.node,
  className: _propTypes.string,
  name: _propTypes.string,
  size: _propTypes.number,
  source: _propTypes.string,
  loaded: _propTypes.number,
  onClose: _propTypes.func
};
var _default = FileBox;
exports.default = _default;